import React from "react"

import {Row} from "react-bootstrap"
import {TextArea} from "@irati/ui/src/FormItem"
import OccasionsSelect from "@irati-web/fields/occasions/OccasionsSelect"
import {CompanyValuesSelect} from "@irati-web/fields/companyValues"
import authentication from "@irati/auth"
import isShareableWithTeams from "@irati/recognition/utils/isShareableWithTeams"
import {InjectIntl, injectIntl} from "@irati/utils/lang"
import {Share} from "@irati-web/fields/poll"
import getSharingOptions, {PRIVATE_OPTION, TEAMS} from "@irati/recognition/constants/share"
import {RecognitionInput} from "@irati/types"
import Validation from "@irati/utils/validation"
import {DistributePayload, DistributeOnChange} from "../../../containers/AdminReward/DistributeReward"
import DistributeRewardStepIndicator from "./DistributeRewardStepIndicator"
import {RewardValueTypes} from "./DistributeRewardStep1"

interface Props extends InjectIntl {
  payload: DistributePayload,
  onPayloadChange: DistributeOnChange,
  recognition: RecognitionInput,
  setRecognition: (recognition: RecognitionInput) => void,
  assignReward: string
}

const MESSAGE_MAX_LENGTH = 280

const DistributeRewardStep2: React.FC<Props> = ({onPayloadChange, payload, recognition, setRecognition, assignReward, formatMessage}) => {
  const canShareWithEveryone = authentication.apps("recognition.recognition.everyone")
  const user = authentication.user()
  let canBeSharedWithTeams = isShareableWithTeams(user, recognition)
  const sharingOptions = getSharingOptions(formatMessage, canShareWithEveryone, canBeSharedWithTeams)

  const handleMessage = (message: string) => {
    onPayloadChange({
      ...payload,
      message
    })
    setRecognition({
      ...recognition,
      message
    })
  }

  const handleUpdateOccasion = (occasionId: string) => {
    setRecognition({...recognition, occasionId})
  }

  const handleUpdateShareChange = (recognitionObj: any, key: string, value: any) => {
    let newRecognition = {
      ...recognitionObj,
      [key]: value
    }

    canBeSharedWithTeams = isShareableWithTeams(user, newRecognition)

    if (!canBeSharedWithTeams && newRecognition.share.value === TEAMS) {
      newRecognition = {
        ...newRecognition,
        share: PRIVATE_OPTION(formatMessage)
      }
    }

    setRecognition(newRecognition)
  }

  return (
    <>
      <DistributeRewardStepIndicator currentStep={2} />
      <Row>
        <TextArea
          label="wallet.reward.admin.distribute.messageBox.label"
          name="messageBox"
          onChange={handleMessage}
          value={payload.message}
          validation={Validation.string("platform.defaultValidation.required").max(MESSAGE_MAX_LENGTH)}
          rows={5} />
      </Row>

      {authentication.apps("recognition") && assignReward === RewardValueTypes.Employees &&
      <Row>
        <Share options={sharingOptions} poll={recognition} onChange={handleUpdateShareChange} hasTeams={canBeSharedWithTeams} />
        <OccasionsSelect selectedOption={recognition.occasionId} onChange={handleUpdateOccasion} />
        <CompanyValuesSelect item={recognition} onChange={handleUpdateShareChange} />
      </Row>}
    </>
  )
}

export default injectIntl(DistributeRewardStep2)

